// Мутации документа. Единственная особенность против других сущностей — карточка
// сохраняет текст документа отдельно от реквизитов, но делает это тем же `update`.
import { createEntityMutations } from '../../../shared/api/createEntityMutations.js';

import {
  createDocument,
  deleteDocument,
  updateDocument,
  type CreateDocumentInput,
  type DocumentListItem,
  type UpdateDocumentInput,
} from '../api/documents.client.js';

const documentMutations = createEntityMutations<
  DocumentListItem,
  CreateDocumentInput,
  UpdateDocumentInput
>({
  key: 'documents',
  // Документ показывается в панелях сделки и контакта.
  alsoInvalidate: ['deals', 'contacts'],
  create: createDocument,
  update: updateDocument,
  remove: deleteDocument,
});

export const useCreateDocumentMutation = documentMutations.useCreate;
export const useUpdateDocumentMutation = documentMutations.useUpdate;
export const useDeleteDocumentMutation = documentMutations.useDelete;
